<template>
  <router-view></router-view>
</template>

<script>
import "./_Home.scss";

export default {
  name: "home",
  props: ["config"],
};
</script>
